import { render, staticRenderFns } from "./newpatient.vue?vue&type=template&id=3c52a5dc&scoped=true"
import script from "./newpatient.vue?vue&type=script&lang=js"
export * from "./newpatient.vue?vue&type=script&lang=js"
import style0 from "./newpatient.vue?vue&type=style&index=0&id=3c52a5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52a5dc",
  null
  
)

export default component.exports